import {fetchRequestSend} from "../../helpers/common-helpers";

export default class EditorQuizzesChecking {
    constructor() {
        //this.eventListeners();
    }

    getInstance() {
        this.eventListeners();
    }

    eventListeners() {
        window.addEventListener('click', (e) => {
            if (e.target.closest('.lesson-submit-quiz')) {
                this.submitQuiz(e);
            }

            if (e.target.closest('.multiple-choice-item')) {
                this.clearPreviousResult(e);
            }
        });
    }

    submitQuiz(e) {
        let quizType = e.target.dataset.quiz;
        let section = e.target.closest('.editor-section');
        let component_id = section && section.id ? section.id.trim() : null;
        // make array with user answers
        let userAnswers = [];
        let userAnswersObj = {};

        // get topic row by topic_id from URL
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);
        this.topic_id = params.get('topic_id') || (typeof topicId !== 'undefined' ? topicId : null) || window.topicId || null;

        // Prefer exact match; otherwise fall back to the first progress row
        let topicRow = null;
        if (this.topic_id) {
            topicRow = document.querySelector(`.tr-course-progress[data-row-topic-id="${this.topic_id}"]`);
        }
        if (!topicRow) {
            topicRow = document.querySelector('.tr-course-progress');
            if (!this.topic_id && topicRow) {
                this.topic_id = topicRow.dataset.rowTopicId || null;
            }
        }

        const parentLesson = topicRow ? (topicRow.dataset.rowParentLesson || '') : '';
        if (parentLesson !== '') {
            this.topic_id = parentLesson;
        }
        switch (quizType) {
            case 'multiple-choice':
                let filled = this.requiredMultipleChoice(component_id, section);
                if(filled === false) {
                    section.querySelector('.quiz-matching-result').innerHTML = `<span class="quiz-matching-result_notification">Please select an answer</span>`;
                    return;
                }
                userAnswers = this.getMultipleChoiceAnswers(component_id, section);
                break;
            case 'matching':
                let filledMatching = this.requiredMatching(component_id, section);
                if(filledMatching === false) {
                    section.querySelector('.quiz-matching-result').innerHTML = `<span class="quiz-matching-result_notification">Please match all items</span>`;
                    return;
                }
                userAnswers = this.getMatchingAnswers(component_id, section);
                break;
        }
        userAnswersObj[component_id] = userAnswers;
        //console.log(userAnswersObj);
        let json_data = {
            'component_id': component_id,
            'user_answers': userAnswers,
            'type': quizType,
            'topic_id': this.topic_id,
        }
        // console.log(json_data)
        fetchRequestSend(checkEditorQuizUrl, 'POST', json_data).then((response) => {
            switch (quizType) {
                case 'multiple-choice':
                    this.showMultipleChoiceResult(response, section);
                    break;
                case 'matching':
                    this.showMatchingResult(response, section);
                    break;
            }

            if(response.status.overall_status){
                e.target.closest('.editor-section').querySelector('.quiz-matching-result').innerHTML = `<span class="quiz-matching-result_correct">Correct</span>`;
            } else {
                e.target.closest('.editor-section').querySelector('.quiz-matching-result').innerHTML = `<span class="quiz-matching-result_incorrect">Incorrect</span>`;

                if (quizType === 'matching') {
                    const textHelp = document.createElement('p');
                    textHelp.classList.add('quiz-matching-result_help');
                    textHelp.innerHTML = 'Correct matching pairs:';
                    e.target.closest('.editor-section').querySelector('.quiz-matching-result').appendChild(textHelp);
                }
            }
        });
    }

    getMultipleChoiceAnswers(component_id, section) {
        let userAnswers = [];
        let answers;
        if (component_id) {
            answers = document.querySelectorAll(`#${component_id} input[type=radio]:checked`);
        } else if (section) {
            answers = section.querySelectorAll('input[type=radio]:checked');
        } else {
            answers = [];
        }
        answers.forEach((answer) => {
            userAnswers.push(answer.closest('.multiple-choice-item').querySelector('.multiple-choice-item_content span').textContent);
        });
        return userAnswers;
    }

    getMatchingAnswers(component_id, section) {
        let userAnswers = [];
        let answers;
        let matching;
        if (component_id) {
            answers = document.querySelectorAll(`#${component_id} .matching-questions_item`);
            matching = document.querySelectorAll(`#${component_id} .matching-answers_item`);
        } else if (section) {
            answers = section.querySelectorAll('.matching-questions_item');
            matching = section.querySelectorAll('.matching-answers_item');
        } else {
            answers = [];
            matching = [];
        }
        answers.forEach((answer, index) => {
            userAnswers.push({
                question: answer.querySelector('span').textContent,
                matching: matching[index].querySelector('span').textContent
            });
        });

        return userAnswers;
    }

    requiredMultipleChoice(component_id, section) {
        // if multiple choice
        let filled = true;
        let answers;
        if (component_id) {
            answers = document.querySelectorAll(`#${component_id} input[type=radio]:checked`);
        } else if (section) {
            answers = section.querySelectorAll('input[type=radio]:checked');
        } else {
            answers = [];
        }
        if (answers.length === 0) {
            filled = false;
        }
        return filled;
    }

    requiredMatching(component_id, section) {
        // if all .matching-questions_item has class .dragged-right then return true
        let filled = true;
        let answers;
        if (component_id) {
            answers = document.querySelectorAll(`#${component_id} .matching-questions_item`);
        } else if (section) {
            answers = section.querySelectorAll('.matching-questions_item');
        } else {
            answers = [];
        }
        answers.forEach((answer) => {
            if (!answer.classList.contains('dragged-right')) {
                filled = false;
            }
        });
        return filled;
    }

    showMultipleChoiceResult(data, section) {
        const itemsList = section.querySelector('.multiple-choice-activity');
        const items = itemsList.querySelectorAll('.multiple-choice-item');

        if (data) {
            const { correct_option_id } = data.status[0];

            for (let i = 0; i < items.length; i++) {
                items[i].classList.remove('is-incorrect');

                if (correct_option_id === +items[i].dataset.id) {
                    items[i].classList.add('is-correct');
                } else {
                    const userAnswers = [...section.querySelectorAll('.radio-element-indicator input')];
                    const isCheckedInputsArray = userAnswers.map(input => input.checked);

                    if (isCheckedInputsArray[i]) {
                        userAnswers[i].closest('.multiple-choice-item').classList.add('is-incorrect');
                    }
                }
            }
        }
    }

    showMatchingResult(data, section) {
        const itemsList = section.querySelector('.matching-activity');
        const answerItems = itemsList.querySelectorAll('.matching-answers_item span');
        const questionItems = itemsList.querySelectorAll('.matching-questions_item span');

        if (!data || !data.status || !Array.isArray(data.status)) {
            return;
        }

        for (let i = 0; i < questionItems.length; i++) {
            const statusItem = data.status[i];
            if (!statusItem) {
                continue;
            }
            const question = questionItems[i];
            question.textContent = statusItem.question ?? question.textContent;

            const answer = answerItems[i];
            answer.textContent = statusItem.correct_matching ?? answer.textContent;
        }
    }

    clearPreviousResult(e) {
        const section = e.target.closest('.editor-section');
        const itemsList = section.querySelector('.multiple-choice-activity');
        const items = itemsList.querySelectorAll('.multiple-choice-item');

        items.forEach(item => item.classList.remove('is-correct', 'is-incorrect'));
    }
}
